import { createSelector } from 'reselect'
import getSummaryByMemberIdSquadSelector from 'modules/squad/redux/selectors/get-summary-by-member-id'

const getSummaryDataByMemberIdSquadSelector = id => createSelector(
  getSummaryByMemberIdSquadSelector(id),
  /**
   * @returns {import('modules/squad/types').GetSquadSummaryResp}
   */
  (squadSummary) => {
    return squadSummary?.data
  }
)

export default getSummaryDataByMemberIdSquadSelector
